import axios from "axios";

// Use same-origin so the dashboard talks to whichever domain you're currently on
// (apex vs www, production vs preview). Avoids cross-origin credentialed-request
// failures when www → apex redirects strip the POST mid-flight.
const BASE = "/api/dashboard";

export const dashApi = axios.create({
  baseURL: BASE,
  withCredentials: true,  // send/receive httpOnly cookies
  headers: { "Content-Type": "application/json" },
});

// Surface server-side validation messages cleanly
dashApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail)) {
      err.message = detail.map((d) => d.msg || d).join("; ");
    } else if (typeof detail === "string") {
      err.message = detail;
    }
    return Promise.reject(err);
  }
);
